import { lessonCategoriesList } from "config/optionValues";
import { MdClose } from "react-icons/md";

interface CategoryLessonPillProps {
  lesson: string;
  setLessonCategories: React.Dispatch<React.SetStateAction<string[]>>;
}

const CategoryLessonPill: React.FC<CategoryLessonPillProps> = ({
  lesson,
  setLessonCategories,
}) => {
  // Map the lesson into its corresponding display value
  const lessonInfoList = lessonCategoriesList.filter(
    (option: { text: string; value: string }) => option.value === lesson
  );

  // Check the lesson info in order to make sure that there is any content
  const lessonInfo =
    lessonInfoList && lessonInfoList.length > 0
      ? lessonInfoList[0]
      : { text: "-" };

  /**
   * Function executed when clicking the cross on the pill
   */
  const handleCloseClick = () => {
    // Remove this item from the selected lessons list
    setLessonCategories((currentList) =>
      currentList.filter((item: string) => lesson !== item)
    );
  };

  return (
    <div className="pl-3 pr-2 py-2 bg-neutral-50 rounded-3xl flex justify-start items-center gap-2">
      <div className="justify-start text-neutral-700 text-base font-normal font-sans leading-tight select-none">
        {lessonInfo.text}
      </div>
      <div
        className="w-5 h-5 rounded-full hover:bg-neutral-200 ease-in-out duration-150 inline-flex justify-center items-center cursor-pointer"
        onClick={handleCloseClick}
      >
        <MdClose className="w-4 h-4 fill-neutral-700" />
      </div>
    </div>
  );
};

export default CategoryLessonPill;
